import React from 'react';
import BannerAnim from 'rc-banner-anim';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import { Button } from 'antd';
import './assets/index.css';
import './assets/main.css';
import './assets/bgParallax.css';

const { Element } = BannerAnim;
const BgElement = Element.BgElement;
function Banner() {
    return (
        <div className="banner-height">
        <div className="bg-imggg" id="banner">
            <BannerAnim type="across">
                <Element key="aaa"prefixCls="banner-user-elem">
                    <BgElement key="bg" className="bg" id="st"
                    /* scrollParallax={{ y: 100 }} */
                    />

                    <QueueAnim name="QueueAnim" className="QueueAnim-container" >
                        <h1 key="h1" className="bnner-title">Artificial Intelligence (AI)</h1>
                        <p key="p" className="sub-title">A one year AI program in Python, Numpy, Pandas, deep learning with Tensorflow, AI model deployment with Kubernetes and Kubeflow, and micro services development using Flask.</p>
                    </QueueAnim>
                    <TweenOne className="QueueAnim-container" animation={{ y: 50, opacity: 0, type: 'from', delay: 200 }} name="TweenOne">
                        <Button type="primary" className="banner-button">FIND MORE</Button>
                    </TweenOne>

                </Element>
                <Element key="bbb" prefixCls="banner-user-elem">
                    <BgElement key="bg" className="bg" id="nd"
                    /* scrollParallax={{ y: 100 }} */
                    />
                    <QueueAnim name="QueueAnim" className="QueueAnim-container">
                        <h1 key="h1" className="bnner-title">Blockchain Development</h1>
                        <p key="p" className="sub-title"> one year Blockchain program in business foundations of Blockchain, Ethereum, Smart Contracts, Dapps, and crypto currencies.</p>
                    </QueueAnim>
                    <TweenOne className="QueueAnim-container" animation={{ y: 50, opacity: 0, type: 'from', delay: 200 }} name="TweenOne">
                        <Button type="primary" className="banner-button">FIND MORE</Button>
                    </TweenOne>
                </Element>
                <Element key="bbb" prefixCls="banner-user-elem">
                    <BgElement key="bg" className="bg" id="rd"
                    /* scrollParallax={{ y: 100 }} */
                    />
                    <QueueAnim name="QueueAnim" className="QueueAnim-container">
                        <h1 key="h1" className="bnner-title">Cloud Native Computing    </h1>
                        <p key="p" className="sub-title">A one year Cloud Native program covering Docker, Terraform, Kubernetes, Helm, Operators,
                         Istio, Knative, GitOps, and cloud native patterns using the multicloud strategy.</p>
                    </QueueAnim>
                    <TweenOne className="QueueAnim-container" animation={{ y: 50, opacity: 0, type: 'from', delay: 200 }} name="TweenOne">
                        <Button type="primary" className="banner-button">FIND MORE</Button>
                    </TweenOne>
                </Element>
                <Element key="bbb" prefixCls="banner-user-elem">
                    <BgElement key="bg" className="bg" id="frth"
                    /* scrollParallax={{ y: 100 }} */
                    />
                    <QueueAnim name="QueueAnim" className="QueueAnim-container">
                        <h1 key="h1" className="bnner-title">Internet of Things (IoT)    </h1>
                        <p key="p" className="sub-title">A one year program IoT program covering Rust, Embedded Rust, Async Rust, Web Apps using Assembly, Edge and Cloud Computing.</p>
                    </QueueAnim>
                    <TweenOne className="QueueAnim-container" animation={{ y: 50, opacity: 0, type: 'from', delay: 200 }} name="TweenOne">
                        <Button type="primary" className="banner-button">FIND MORE</Button>
                    </TweenOne>
                </Element>
            </BannerAnim>
        </div>
        </div>
    );
}

export default Banner;